export const DateTimeQcFieldName = 'dateTimeQcFieldComponent';

export const DATE_MIN_ALLOWED = new Date(1753, 0, 1);
export const DATE_MAX_ALLOWED = new Date(9999, 11, 31, 23, 59, 59, 999);
